export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const REMOVE_NOTIFICATIONS = 'REMOVE_NOTIFICATIONS'
export const NOTIFICATIONS_FAIL = 'NOTIFICATIONS_FAIL'
export const SET_LOADING = 'SET_LOADING'
